import { useState } from 'react';
import { Link } from 'react-router-dom';

const SERVICES = [
  {
    icon: 'ri-layout-grid-line',
    title: 'Flooring Installation',
    desc: 'Hardwood, LVP, laminate, and engineered wood — every plank placed with precision.',
    image: 'https://public.readdy.ai/ai/img_res/2ca49f401f13c3810c87e675e115e49c.jpg',
    link: '/flooring-installation',
  },
  {
    icon: 'ri-delete-bin-line',
    title: 'Dustless Demolition',
    desc: 'Remove tile, glue-down floors, and surfaces without filling your home with dust.',
    image: 'https://readdy.ai/api/search-image?query=professional%20dustless%20floor%20removal%20equipment%2C%20industrial%20vacuum%20system%20connected%20to%20floor%20grinder%20removing%20old%20tile%20flooring%2C%20clean%20organized%20job%20site%20with%20dust%20containment%20system%2C%20bright%20modern%20home%20interior%2C%20professional%20construction%20equipment&width=600&height=400&seq=vmdust002&orientation=landscape',
    link: '/contact',
  },
  {
    icon: 'ri-tools-line',
    title: 'Subfloor Prep & Leveling',
    desc: 'Self-leveling, plywood repair, and moisture solutions. No shortcuts, ever.',
    image: 'https://readdy.ai/api/search-image?query=professional%20subfloor%20leveling%20and%20preparation%20work%2C%20construction%20worker%20applying%20self%20leveling%20compound%20on%20concrete%20floor%2C%20precision%20tools%20and%20moisture%20barriers%20visible%2C%20bright%20renovation%20interior%20space%2C%20professional%20flooring%20contractor%20at%20work&width=600&height=400&seq=vmsubfloor002&orientation=landscape',
    link: '/contact',
  },
  {
    icon: 'ri-building-2-line',
    title: 'Bathroom Remodeling',
    desc: 'Full bathroom renovations — tile, showers, vanities, and waterproofing done right.',
    image: 'https://readdy.ai/api/search-image?query=modern%20luxury%20bathroom%20remodel%20with%20large%20format%20porcelain%20tiles%20on%20walls%20and%20floor%2C%20freestanding%20bathtub%2C%20frameless%20glass%20shower%2C%20warm%20beige%20and%20white%20color%20palette%2C%20bright%20natural%20light%20from%20window%2C%20high%20end%20interior%20design%2C%20professional%20photography&width=600&height=400&seq=vmbath002&orientation=landscape',
    link: '/bathroom-remodeling',
  },
  {
    icon: 'ri-grid-line',
    title: 'Tile Installation',
    desc: 'Porcelain, ceramic, and large-format tile for floors and walls — set with precision.',
    image: 'https://readdy.ai/api/search-image?query=professional%20tile%20installation%20in%20modern%20home%20interior%2C%20large%20format%20light%20porcelain%20tiles%20being%20laid%20with%20perfect%20grout%20lines%2C%20bright%20contemporary%20kitchen%20or%20bathroom%20setting%2C%20clean%20crisp%20tile%20work%2C%20natural%20light%2C%20minimal%20background&width=600&height=400&seq=vmtile001&orientation=landscape',
    link: '/flooring-installation',
  },
];

export default function ServicesSection() {
  const [hovered, setHovered] = useState<number | null>(null);

  return (
    <section className="bg-[#faf8f5] py-20 px-4 md:px-8">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="mb-10">
          <p className="text-[#c9a55a] text-xs font-bold uppercase tracking-[0.3em] mb-3">What We Do</p>
          <div className="flex flex-col md:flex-row md:items-end justify-between gap-4">
            <h2 className="text-3xl md:text-4xl font-black text-[#1c1a17] leading-tight">
              Core Services
            </h2>
            <Link
              to="/flooring-installation"
              className="flex items-center gap-2 text-[#c9a55a] hover:text-[#a68a4a] text-sm font-semibold transition-colors whitespace-nowrap cursor-pointer group"
            >
              View All Services
              <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
            </Link>
          </div>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {SERVICES.map((service, idx) => (
            <Link
              to={service.link}
              key={service.title}
              className="group relative bg-white rounded-xl overflow-hidden border border-[#e5e0d8] hover:border-[#c9a55a]/40 transition-all duration-300 cursor-pointer block"
              onMouseEnter={() => setHovered(idx)}
              onMouseLeave={() => setHovered(null)}
              style={{
                transform: hovered === idx ? 'translateY(-6px)' : 'translateY(0)',
                transition: 'transform 0.3s ease, border-color 0.3s ease',
              }}
            >
              {/* Image */}
              <div className="w-full h-40 overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>

              {/* Content */}
              <div className="p-4">
                <div className="w-8 h-8 flex items-center justify-center mb-3">
                  <i className={`${service.icon} text-[#c9a55a] text-xl`} />
                </div>
                <h3 className="text-sm font-bold text-[#1c1a17] mb-2">{service.title}</h3>
                <p className="text-[#6b6560] text-xs leading-relaxed mb-4">{service.desc}</p>
                <div className="flex items-center gap-1 text-[#c9a55a] text-xs font-semibold group-hover:gap-2 transition-all">
                  Learn More <i className="ri-arrow-right-line" />
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
